import { useState, useEffect } from 'react';
import Toggle from '../Toggle';
import { resizeImage } from '../util';

const ROLES = ['set principal', 'closing', 'apertura'];

export default function TabConfigurar({ event, api, reload }) {
  const [f, setF] = useState({
    name: event.name || '',
    date: event.date ? String(event.date).slice(0, 10) : '',
    start_time: event.start_time || '',
    end_time: event.end_time || '',
    venue: event.venue || '',
    flyer_url: event.flyer_url || null,
    published: !!event.published,
    minors_audience: !!event.minors_audience,
    birthday_enabled: !!event.birthday_enabled,
    birthday_from: event.birthday_from ? String(event.birthday_from).slice(0, 10) : '',
    birthday_to: event.birthday_to ? String(event.birthday_to).slice(0, 10) : '',
    birthday_benefit: event.birthday_benefit || '',
    // datetime-local quiere 'YYYY-MM-DDTHH:mm' y sin la Z: se corta el ISO.
    birthday_signup_until: event.birthday_signup_until ? String(event.birthday_signup_until).slice(0, 16) : '',
    birthday_limit: event.birthday_limit != null ? String(event.birthday_limit) : '',
  });
  const [copiadoCumple, setCopiadoCumple] = useState(false);
  const [copiado, setCopiado] = useState(false);
  // El flyer lo sirve el BACKEND (ahí está el endpoint), que en producción es otro host
  // que la web: por eso la URL se arma con la del API y no con la de la página.
  const apiBase = process.env.REACT_APP_API_URL || window.location.origin;
  const flyerUrl = `${apiBase}/api/public/event/${event.id}/flyer`;
  const copiarFlyer = async () => {
    try { await navigator.clipboard.writeText(flyerUrl); setCopiado(true); setTimeout(() => setCopiado(false), 1800); }
    catch { window.prompt('Copiá el link del flyer:', flyerUrl); }
  };
  // La página de cumpleaños la sirve la WEB, no el backend: va con el origen actual. El
  // panel vive en el mismo host que el sitio público (lobbo.tukipro.com/admin), así que
  // este origen es el que le sirve a la gente.
  const cumpleUrl = `${window.location.origin}/e/${event.id}/cumple`;
  const copiarCumple = async () => {
    try { await navigator.clipboard.writeText(cumpleUrl); setCopiadoCumple(true); setTimeout(() => setCopiadoCumple(false), 1800); }
    catch { window.prompt('Copiá el link para la historia:', cumpleUrl); }
  };

  const [lineup, setLineup] = useState(
    (event.lineup || []).map(r => Array.isArray(r) ? { name: r[0] || '', role: r[1] || 'set principal', time: r[2] || '' } : r)
  );
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF(s => ({ ...s, [k]: v }));

  useEffect(() => { if (!saved) return; const t = setTimeout(() => setSaved(false), 2200); return () => clearTimeout(t); }, [saved]);

  const onFlyer = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    try { set('flyer_url', await resizeImage(file, 1200, 0.8)); }
    catch (err) { alert(err.message || 'No se pudo procesar la imagen'); }
  };
  const addDj = () => setLineup(l => [...l, { name: '', role: 'set principal', time: '' }]);
  const setDj = (i, k, v) => setLineup(l => l.map((r, j) => j === i ? { ...r, [k]: v } : r));
  const rmDj = (i) => setLineup(l => l.filter((_, j) => j !== i));

  async function save() {
    setSaving(true);
    try {
      await api.patch(`/api/events/${event.id}`, {
        name: f.name.toUpperCase(), date: f.date || null, start_time: f.start_time,
        end_time: f.end_time, venue: f.venue, flyer_url: f.flyer_url, published: f.published,
        minors_audience: f.minors_audience,
        birthday_enabled: f.birthday_enabled,
        birthday_from: f.birthday_from || null,
        birthday_to: f.birthday_to || null,
        birthday_benefit: f.birthday_benefit,
        // El input da hora LOCAL sin zona; se manda como ISO real para que el cierre
        // signifique lo mismo en el server (que corre en UTC) que en la pantalla.
        birthday_signup_until: f.birthday_signup_until ? new Date(f.birthday_signup_until).toISOString() : null,
        // Vacío o 0 = sin tope. Se manda null para no guardar un cupo de cero, que
        // dejaría la lista cerrada sin que nadie lo haya pedido.
        birthday_limit: f.birthday_limit === '' ? null : (Number(f.birthday_limit) || null),
        lineup: lineup.filter(r => r.name.trim()).map(r => [r.name, r.role, r.time]),
      });
      setSaved(true); reload();
    } catch (e) { alert(e.message); } finally { setSaving(false); }
  }

  return (
    <div className="lb-fade tk-2col" style={{ paddingTop: 30, display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: 32, alignItems: 'start' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
        <Field label="Nombre del evento"><input className="lb-input" value={f.name} onChange={e => set('name', e.target.value)} /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
          <Field label="Fecha"><input className="lb-input" type="date" value={f.date} onChange={e => set('date', e.target.value)} /></Field>
          <Field label="Inicio"><input className="lb-input" type="time" value={f.start_time} onChange={e => set('start_time', e.target.value)} /></Field>
          <Field label="Fin"><input className="lb-input" type="time" value={f.end_time} onChange={e => set('end_time', e.target.value)} /></Field>
        </div>
        <Field label="Lugar"><input className="lb-input" value={f.venue} onChange={e => set('venue', e.target.value)} placeholder="Ej: nombre y dirección del lugar" /></Field>

        <div>
          <div className="lb-label" style={{ marginBottom: 10 }}>DJ set · Lineup</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {lineup.map((row, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 0.7fr auto', gap: 8 }}>
                <input className="lb-input" style={{ padding: '10px 12px', fontSize: 13 }} placeholder="DJ / Artista" value={row.name} onChange={e => setDj(i, 'name', e.target.value)} />
                <select className="lb-select" style={{ padding: '10px 12px', fontSize: 13 }} value={row.role} onChange={e => setDj(i, 'role', e.target.value)}>
                  {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
                <input className="lb-input" style={{ padding: '10px 12px', fontSize: 13 }} placeholder="02:00" value={row.time} onChange={e => setDj(i, 'time', e.target.value)} />
                <button className="lb-iconbtn" onClick={() => rmDj(i)}>✕</button>
              </div>
            ))}
            <button className="lb-btn lb-btn--ghost lb-btn--sm" style={{ alignSelf: 'flex-start' }} onClick={addDj}>+ Agregar DJ</button>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 14, alignItems: 'center', paddingTop: 6 }}>
          <span className="lb-eyebrow">Estado</span>
          <Toggle on={f.published} onClick={() => set('published', !f.published)} label={f.published ? 'Publicado' : 'Oculto'} />
          <span style={{ fontSize: 12, color: 'var(--ink-600)' }}>Tocá para {f.published ? 'ocultar de' : 'publicar en'} la web</span>
        </div>

        <div style={{ display: 'flex', gap: 14, alignItems: 'center', paddingTop: 12, flexWrap: 'wrap' }}>
          <span className="lb-eyebrow">Público menor</span>
          <Toggle on={f.minors_audience} onClick={() => set('minors_audience', !f.minors_audience)} label={f.minors_audience ? 'Sí (fiesta de 15 / egresados)' : 'No'} />
          <span style={{ fontSize: 12, color: 'var(--ink-600)', flexBasis: '100%' }}>Marcalo en fiestas de 15, egresados o eventos con menores: sus asistentes quedan <b>excluidos del email marketing</b> (protección de datos de menores).</span>
        </div>

        {/* BENEFICIO DE CUMPLEAÑOS. Prendido, la gente se anota sola desde la web y la
            lista queda junto a la que cargan los RRPP. */}
        <div style={{ paddingTop: 20, marginTop: 16, borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap' }}>
            <span className="lb-eyebrow">Lista de cumpleaños</span>
            <Toggle on={f.birthday_enabled} onClick={() => set('birthday_enabled', !f.birthday_enabled)} label={f.birthday_enabled ? 'Se pueden anotar solos' : 'Apagada'} />
          </div>
          <div style={{ fontSize: 12, color: 'var(--ink-600)', marginTop: 8, lineHeight: 1.5 }}>
            Aparece en la web con un botón para anotarse. <b style={{ color: 'var(--ink-800)' }}>Solo se puede anotar quien cumple años entre esas dos fechas y sea mayor de 18</b> — la fecha de nacimiento se valida al anotarse, así nadie llega a la puerta creyendo que estaba adentro.
          </div>

          {f.birthday_enabled && (
            <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Field label="El beneficio va desde"><input className="lb-input" type="date" value={f.birthday_from} onChange={e => set('birthday_from', e.target.value)} /></Field>
                <Field label="Hasta"><input className="lb-input" type="date" value={f.birthday_to} onChange={e => set('birthday_to', e.target.value)} /></Field>
              </div>
              <Field label="Cuál es el beneficio">
                <input className="lb-input" value={f.birthday_benefit} onChange={e => set('birthday_benefit', e.target.value)} placeholder="Ingreso sin cargo y un cupón a elección" />
              </Field>
              <Field label="Hasta cuándo se pueden anotar">
                <input className="lb-input" type="datetime-local" value={f.birthday_signup_until} onChange={e => set('birthday_signup_until', e.target.value)} />
              </Field>
              <div style={{ fontSize: 11.5, color: 'var(--ink-600)', marginTop: -4, lineHeight: 1.5 }}>
                Si lo dejás vacío, se pueden anotar hasta el momento del evento — incluso desde la fila. Poner la hora en que abren las puertas te deja saber de antemano cuánta gente sin cargo esperar.
              </div>

              <Field label="Cupo de la lista">
                <input className="lb-input" inputMode="numeric" value={f.birthday_limit}
                  onChange={e => set('birthday_limit', e.target.value.replace(/\D/g, '').slice(0, 5))} placeholder="Sin tope" />
              </Field>
              <div style={{ fontSize: 11.5, color: 'var(--ink-600)', marginTop: -4, lineHeight: 1.5 }}>
                Cuántos cumpleañeros entran en total. Cuenta a los <b>anotados</b>, no a los que ya retiraron su entrada,
                y lo comparten la web y los RRPP: cuando se llena, deja de aceptar por las dos vías. Vacío = sin tope.
              </div>

              {/* El link de la página, para pegarlo en una historia de Instagram. Es el
                  motivo por el que el formulario es una página aparte y no una ventanita. */}
              <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 12 }}>
                <div className="lb-label" style={{ marginBottom: 6 }}>Link para compartir</div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  <code style={{ fontSize: 11.5, color: 'var(--ink-700)', wordBreak: 'break-all', flex: 1, minWidth: 200 }}>{cumpleUrl}</code>
                  <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={copiarCumple}>{copiadoCumple ? 'Copiado ✓' : 'Copiar'}</button>
                </div>
                <div style={{ fontSize: 11.5, color: 'var(--ink-600)', marginTop: 6 }}>Va directo al formulario. Sirve para la historia de Instagram.</div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div>
        <div className="lb-label" style={{ marginBottom: 10 }}>Flyer</div>
        {/* El flyer se muestra en SU proporción. Antes el recuadro era 1:1 con `cover`:
            un flyer vertical (el formato normal de historia) se veía recortado arriba y
            abajo, así que no se podía comprobar cómo había quedado el que subiste. */}
        <label style={{ display: 'block', width: '100%', border: '1px dashed var(--border)', borderRadius: 4, background: 'var(--ink-050)', cursor: 'pointer', position: 'relative', overflow: 'hidden' }}>
          <input type="file" accept="image/*" onChange={onFlyer} style={{ display: 'none' }} />
          {f.flyer_url
            ? <img src={f.flyer_url} alt="Flyer del evento" style={{ display: 'block', width: '100%', height: 'auto' }} />
            : <div style={{ aspectRatio: '1/1', display: 'grid', placeItems: 'center', color: 'var(--ink-600)', fontSize: 12 }}>Subí el flyer</div>}
        </label>

        {/* Dirección pública del flyer, para pegarla en Meta Ads. El flyer se guarda
            dentro del evento, así que esta URL es un endpoint que lo sirve como imagen:
            un `data:` (lo que hay guardado) no le sirve a Meta, necesita bajarlo por HTTP.
            Solo aparece con el evento YA GUARDADO: si mostráramos el link de un flyer que
            todavía está en el navegador, copiarlo daría un 404. */}
        {f.flyer_url && (
          event.flyer_url === f.flyer_url ? (
            <div style={{ marginTop: 12 }}>
              <div className="lb-label" style={{ marginBottom: 6 }}>Link del flyer (para Meta Ads)</div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                <input className="lb-input" readOnly value={flyerUrl} onFocus={e => e.target.select()}
                  style={{ flex: 1, minWidth: 240, fontFamily: 'monospace', fontSize: 11.5 }} />
                <button className="lb-btn lb-btn--white lb-btn--sm" onClick={copiarFlyer}>{copiado ? 'Copiado ✓' : 'Copiar'}</button>
                <a className="lb-btn lb-btn--ghost lb-btn--sm" href={flyerUrl} target="_blank" rel="noreferrer">Abrir ↗</a>
              </div>
              <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 6 }}>
                La dirección no cambia si reemplazás el flyer: se sirve siempre la versión guardada.
              </div>
            </div>
          ) : (
            <div style={{ marginTop: 12, fontSize: 11.5, color: '#ffb300' }}>
              Guardá los cambios para obtener el link del flyer.
            </div>
          )
        )}
        <div style={{ marginTop: 24, display: 'flex', alignItems: 'center', gap: 14 }}>
          <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save} disabled={saving}>{saving ? 'Guardando…' : 'Guardar cambios'}</button>
          <span style={{ fontSize: 12, color: saved ? '#2ecc71' : 'var(--ink-600)' }}>{saved ? 'Guardado ✓' : ''}</span>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return <div className="lb-field"><div className="lb-label">{label}</div>{children}</div>;
}
